// extracted by mini-css-extract-plugin
export default {"wrapBox":"SelectModal_wrapBox__N+TND","wrapItem":"SelectModal_wrapItem__VJqti","label":"SelectModal_label__FAiAs","type":"SelectModal_type__Cck93","error":"SelectModal_error__w325U"};